import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AppNotification {
  notification_id: string;
  user_id: string;
  title?: string;
  content: string;
  type?: string;
  link: string;
  is_read: boolean;
  created_at: string;
}

interface NotificationsState {
  notifications: AppNotification[];
  unreadCount: number;
  isOpen: boolean;
}

const initialState: NotificationsState = {
  notifications: [],
  unreadCount: 0,
  isOpen: false,
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setNotifications: (state, action: PayloadAction<AppNotification[]>) => {
      state.notifications = action.payload || [];
      state.unreadCount = state.notifications.filter(n => !n.is_read).length;
    },

    addNotification: (state, action: PayloadAction<AppNotification>) => {
      const n = action.payload;

      // de-dupe by notification_id (prevents duplicates on reconnect + sync)
      const exists = state.notifications.some(x => x.notification_id === n.notification_id);
      if (!exists) state.notifications.unshift(n);

      if (!n.is_read && !exists) {
        state.unreadCount += 1;
      }
    },

    updateNotification: (state, action: PayloadAction<string>) => {
      const id = action.payload;
      // Convert to string for reliable comparison (notification_id is typed as string)
      const idStr = String(id);

      const index = state.notifications.findIndex(n => {
        const notifId = String(n.notification_id);
        const match = notifId === idStr;
        if (match) {
        }
        return match;
      });

      if (index !== -1) {
        const wasUnread = !state.notifications[index].is_read;

        state.notifications[index].is_read = true;
        if (wasUnread) {
          state.unreadCount = Math.max(state.unreadCount - 1, 0);
        }

      } else {
        console.warn('[notificationSlice.updateNotification] Notification not found in state:', {
          looking_for_id: idStr,
          available_ids: state.notifications.map(n => String(n.notification_id))
        });
      }
    },

    markAllAsRead: (state) => {
      state.notifications.forEach(n => (n.is_read = true));
      state.unreadCount = 0;
    },

    // [OK] NEW: allow Sidebar / PubSub to set unread count directly
    // (useful when backend is the source of truth)
    setUnreadCount: (state, action: PayloadAction<number>) => {
      state.unreadCount = Math.max(Number(action.payload || 0), 0);
    },

    toggleSidepanel: (state) => {
      state.isOpen = !state.isOpen;
    },

    closeSidepanel: (state) => {
      state.isOpen = false;
    },
  },
});

export const {
  setNotifications,
  addNotification,
  updateNotification,
  markAllAsRead,
  setUnreadCount, // [OK] export new action
  toggleSidepanel,
  closeSidepanel,
} = notificationsSlice.actions;

export default notificationsSlice.reducer;
